// Default is	DD/MM/YYYY
export const UserPreferDateFormatType = {
	/** European Date Format: DD/MM/YYYY */
	DDMMYYYY: 'dd/mm/yyyy',
	/** American Date Format: MM/DD/YYYY */
	MMDDYYYY: 'mm/dd/yyyy',
} as const;
export type UserPreferDateFormatType = (typeof UserPreferDateFormatType)[keyof typeof UserPreferDateFormatType];

export function tryConvertToUserPreferDateFormatType(value: string): UserPreferDateFormatType {
	const convertedValue = (Object.values(UserPreferDateFormatType) as string[]).find(dateFormat => dateFormat.toLowerCase() === value.toLowerCase());
	if (convertedValue) return convertedValue as UserPreferDateFormatType;
	return UserPreferDateFormatType.DDMMYYYY;
}
